import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledRoot = styled.div(() => ({
  flex: '1 1 auto',
}))

const StyledTitle = styled.div(({ previewMode, theme: { spaces, twoRowsLimit } }) => ({
  flex: '1 1 auto',
  marginBottom: spaces.default * 0.5,
  paddingRight: spaces.default,

  ...(previewMode ? twoRowsLimit : {}),
}))

const StyledText = styled.p(({ theme }) => ({
  margin: 0,
  fontSize: theme.fontSize * 0.875,
  lineHeight: `${theme.fontSize}px`,
}))

const ProductName = ({
  hideProductsTitle,
  name,
  previewMode,
}) => name && !hideProductsTitle && (
  <StyledRoot>
    <StyledTitle data-test="ProductName" previewMode={previewMode}>
      <StyledText>
        {name}
      </StyledText>
    </StyledTitle>
  </StyledRoot>
)

ProductName.propTypes = {
  hideProductsTitle: PropTypes.bool,
  name: PropTypes.string,
  previewMode: PropTypes.bool,
}

ProductName.defaultProps = {
  hideProductsTitle: false,
  name: '',
  previewMode: false,
}

ProductName.displayName = 'ProductName'
ProductName.whyDidYouRender = true

export default ProductName
